import { translate, localHref } from "../i18n";
import LanguageSwitcher from "../components/LanguageSwitcher";
import SiteFooter from "../components/SiteFooter";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, ArrowUpRight, Check } from "@phosphor-icons/react";
import { SEO_PAGE_MAP, SEO_PAGES } from "../content/seoPages";
const RECOMMENDED = {
  "stampati-aziendali": ["biglietti-da-visita", "brochure-cataloghi-riviste", "adesivi-etichette"],
  "biglietti-da-visita": ["stampati-aziendali", "brochure-cataloghi-riviste", "adesivi-etichette"],
  "brochure-cataloghi-riviste": ["biglietti-da-visita", "stampati-aziendali", "packaging-personalizzato"],
  "adesivi-etichette": ["packaging-personalizzato", "stampati-aziendali", "materiali-eventi-grande-formato"],
  "calendari-personalizzati": ["stampati-aziendali", "biglietti-da-visita", "packaging-personalizzato"],
  "packaging-personalizzato": ["adesivi-etichette", "stampati-aziendali", "brochure-cataloghi-riviste"],
  "materiali-eventi-grande-formato": ["brochure-cataloghi-riviste", "stampati-aziendali", "adesivi-etichette"],
  "stampa-digitale-ticino": ["biglietti-da-visita", "stampati-aziendali", "brochure-cataloghi-riviste"]
};
export default function ServicePage() {
  const {
    slug
  } = useParams();
  const page = SEO_PAGE_MAP[slug];
  if (!page) return <main className="sp-not-found">
        <h1>{translate("Pagina non trovata")}</h1>
        <Link to="/">{translate("Torna alla homepage")}</Link>
      </main>;
  const quote = `/?prodotto=${encodeURIComponent(page.title)}#contatti`;
  return <div className="sp">
      <header className="sp-header">
        <div className="sp-wrap">
          <Link to="/" className="sp-logo">
            <img src="/images/pedrazzini-print365-640.webp" alt="Pedrazzini Print 365" />
          </Link>
          <nav>
            <Link to="/#prodotti">{translate("Prodotti")}</Link>
            <Link to="/#servizi">{translate("La stampa")}</Link>
            <Link to="/proposte/natale-2026/">{translate("Questo mese")}</Link>
            <a className="sp-header-cta" href={localHref(quote)}>{translate("Preventivo ")}<ArrowUpRight size={20} />
            </a>
          </nav><LanguageSwitcher />
        </div>
      </header>
      <main>
        <section className="sp-hero">
          <div className="sp-wrap sp-hero-grid">
            <div>
              <Link className="sp-back" to="/#prodotti">
                <ArrowLeft />{translate(" Tutti i prodotti")}</Link>
              <p className="sp-kicker">{page.eyebrow} · LOCARNO</p>
              <h1>{page.title}</h1>
              <p className="sp-lead">{page.lead}</p>
              <a className="sp-button" href={localHref(quote)}>{translate("Richiedi un preventivo ")}<ArrowUpRight size={24} />
              </a>
            </div>
            <div className="sp-hero-image">
              <img src={page.hero} alt={translate("{0} personalizzati da Pedrazzini Print 365", {
              0: page.title
            })} />
              <span>{translate("PREVENTIVO")}<br />
                <strong>{translate("ENTRO 24 ORE")}</strong>
              </span>
            </div>
          </div>
        </section>
        <section className="sp-intro">
          <div className="sp-wrap sp-two">
            <p className="sp-kicker">{translate("DAL PROGETTO ALLA STAMPA")}</p>
            <div>
              <h2>{translate("Una soluzione costruita")}<br />{translate("intorno a ci\xF2 che ti serve.")}</h2>
              <p>{page.intro}</p>
            </div>
          </div>
        </section>
        <section className="sp-specs">
          <div className="sp-wrap sp-spec-grid">
            <div>
              <p className="sp-kicker">{translate("PERCH\xC9 SCEGLIERLO")}</p>
              <h2>{translate("Dettagli che fanno")}<br />{translate("la differenza.")}</h2>
              <ul>
                {page.benefits.map(v => <li key={v}>
                    <Check size={22} />
                    {v}
                  </li>)}
              </ul>
            </div>
            <div className="sp-material">
              <p className="sp-kicker">{translate("MATERIALI E FINITURE")}</p>
              {page.materials.map((v, i) => <div key={v}>
                  <span>0{i + 1}</span>
                  <strong>{v}</strong>
                </div>)}
            </div>
          </div>
        </section>
        <section className="sp-recommended">
          <div className="sp-wrap">
            <p className="sp-kicker">{translate("UN PROGETTO COORDINATO")}</p>
            <h2>{translate("Prodotti consigliati insieme a")}<br />
              {page.title.toLowerCase()}.
            </h2>
            <p className="sp-recommended-intro">{translate("Abbina supporti diversi per presentarti in modo coerente, ridurre i passaggi e organizzare la produzione con un unico referente a Locarno.")}</p>
            <div className="sp-recommended-grid">
              {RECOMMENDED[page.slug].map(slug => {
              const item = SEO_PAGE_MAP[slug];
              return <Link to={`/prodotti/${item.slug}/`} key={item.slug}>
                    <img src={item.hero} alt="" />
                    <div>
                      <span>{item.eyebrow}</span>
                      <strong>{item.title}</strong>
                      <p>{item.description}</p>
                      <b>{translate("Scopri il prodotto ")}<ArrowUpRight size={20} />
                      </b>
                    </div>
                  </Link>;
            })}
            </div>
          </div>
        </section>
        <section className="sp-faq">
          <div className="sp-wrap">
            <p className="sp-kicker">{translate("PRIMA DI STAMPARE")}</p>
            <h2>{translate("Domande utili.")}</h2>
            <div className="sp-faq-grid">
              {page.faq.map(([q, a]) => <article key={q}>
                  <h3>{q}</h3>
                  <p>{a}</p>
                </article>)}
            </div>
          </div>
        </section>
        <section className="sp-related">
          <div className="sp-wrap">
            <p className="sp-kicker">{translate("ALTRE POSSIBILIT\xC0")}</p>
            <div className="sp-related-grid">
              {SEO_PAGES.filter(v => v.slug !== page.slug).slice(0, 3).map(v => <Link to={`/prodotti/${v.slug}/`} key={v.slug}>
                    <span>{v.eyebrow}</span>
                    <strong>{v.title}</strong>
                    <ArrowUpRight size={24} />
                  </Link>)}
            </div>
          </div>
        </section>
        <section className="sp-contact">
          <div className="sp-wrap sp-contact-grid">
            <div>
              <p className="sp-kicker">{translate("PARLIAMONE")}</p>
              <h2>{translate("Hai un progetto?")}<br />
                <span>{translate("Diamogli forma.")}</span>
              </h2>
            </div>
            <div>
              <p>{translate("Raccontaci formato, quantit\xE0, utilizzo e data desiderata. Ti rispondiamo con un preventivo personalizzato entro 24 ore.")}</p>
              <a className="sp-button" href={localHref(quote)}>{translate("Inizia da qui ")}<ArrowUpRight size={24} />
              </a>
            </div>
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>;
}
